module.exports = __webpack_public_path__ + "static/media/css.0152a24d.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/pages/Skills/images/css.png
// module id = 109
// module chunks = 0